import { BausteineAnsicht } from "@/components/bausteine/BausteineAnsicht";

// Einstellungen → Bausteine: dieselbe Ansicht wie Leiste, Fenster und Handy (eine Stelle, keine zweite Liste)
const BloeckePanel = ({ blocks, onNeuLaden, onInsert, onCloseSettings }) => (
  <BausteineAnsicht bloecke={blocks} onNeuLaden={onNeuLaden} modus="einstellungen"
    onEinfuegen={(block, liste) => { const ok = onInsert(block, liste); if (onCloseSettings) onCloseSettings(); return ok; }} />
);

export { BloeckePanel };
